import { initializeIcons } from "@fluentui/react/lib/Icons";
import React from "react";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { Authentication } from "./auth/Authentication";
import { authProvider } from "./auth/authProvider";
import setupStore from "./redux/setupStore";
import { unregister } from "./registerServiceWorker";

initializeIcons();

const store = setupStore();

ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <BrowserRouter>
        <Authentication provider={authProvider} forceLogin>
          <App />
        </Authentication>
      </BrowserRouter>
    </CookiesProvider>
  </Provider>,

  document.getElementById("root"),
);

unregister();
